export default {"src":"/_next/static/media/pricing.3c3ecdfe.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};